import React from "react";
import ScrollButton from "../ScrollButton";

const NextButton = ({ currentSlide, slideCount, slidesToShow, onClick }) => {
  const isLastSlide = currentSlide + slidesToShow === slideCount;

  return !isLastSlide ? <ScrollButton direction="right" onClick={onClick} /> : null;
};

export default NextButton;



// WEBPACK FOOTER //
// ./src/components/HorizontalSlider/components/NextButton/index.js